/**
 * function to parse a given text using delimiters and returns an array of arrays
 * @param {} content
 * @param {*} delimiter
 */
export function parse(content, delimiter, linebreak) {
  const data = [];
  if (content) {
    content.split(linebreak).forEach((line) => {
      if (line.length > 0) {
        const columns = [];
        line.split(delimiter).forEach((column) => {
          columns.push(column);
        });
        data.push(columns);
      }
    });
  }
  return data;
}
